export const regEx = type => {
    let regExobj = {
        email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        text: /^(?!\s*$).+/,
        name: /^[a-zA-Z]([a-zA-Z\s])+$/,
        textarea: /[A-Za-z0-9'.\-\s,]+/,
        tel: /^(\+\d{1,3}[- ]?)?\d{10}$/
    };
    let regExRule = regExobj[type];
    let ex = new RegExp(regExRule);
    return ex;
};